import { render, staticRenderFns } from "./Admin-Layout.vue?vue&type=template&id=02c505e1"
import script from "./Admin-Layout.vue?vue&type=script&lang=js"
export * from "./Admin-Layout.vue?vue&type=script&lang=js"
import style0 from "./Admin-Layout.vue?vue&type=style&index=0&id=02c505e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports